// extracted by mini-css-extract-plugin
module.exports = {"due_date_container":"DueDate_due_date_container__3J1V0","due_date":"DueDate_due_date__31YlM"};